import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

export default function RouteFallback({ label = 'Loading module...' }) {
  return (
    <Box sx={{ p: 3, width: '100%' }}>
      <Typography variant='caption' sx={{ mb: 1, display: 'block', letterSpacing: 0.5 }}>
        {label}
      </Typography>
      <Skeleton variant='rectangular' height={32} sx={{ mb: 2, maxWidth: 360 }} />
      <Skeleton variant='rectangular' height={200} sx={{ mb: 2 }} />
      <Skeleton variant='text' />
      <Skeleton variant='text' width='60%' />
    </Box>
  );
}
